module.exports = __webpack_public_path__ + "user-add.e55724ef589ca4bb5cea.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/user-add.svg
// module id = ../../../../../src/img/icon/user-add.svg
// module chunks = styles